<template>
  <div class="wlx-stu-self-info-wrapper">
    <el-form ref="form" :model="form" label-width="120px" class="stu-self-form">
      <el-form-item label="姓名：">
        <el-input v-model="form.Name"></el-input>
      </el-form-item>
      <el-form-item label="头像：">
        <imageUpload :url="urlAliyunOSS" :files.sync="form.CoverUrl" format="image"></imageUpload>
      </el-form-item>
      <el-form-item label="性别：">
        <el-radio-group v-model="form.Gender">
          <el-radio label="0">男</el-radio>
          <el-radio label="1">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="身份证号：" prop="iDNumber">
        <el-input v-model="form.IDNumber"></el-input>
      </el-form-item>
      <el-form-item label="所在学校:">
          <el-select v-model="form.School" clearable placeholder="请选择">
            <el-option
              v-for="item in schoolList"
              :key="item.Id"
              :label="item.SchoolName"
              :value="item.Id">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="学号:">
        <el-input v-model="form.Number"></el-input>
      </el-form-item>
      <el-form-item label="手机号:">
        <el-input v-model="form.mobile" disabled="disabled"></el-input>
      </el-form-item>
      <el-form-item label="简介：">
        <el-input type="textarea" :rows="4" v-model="form.Desc"></el-input>
      </el-form-item>
      <el-form-item >
        <el-button
              v-if="!wsxx"
              type="primary"
              class="captcha-phone-button"
              @click="updateBasicInfo()"
            >保存</el-button>
        <el-button
              v-if="wsxx"
              type="primary"
              class="captcha-phone-button"
              style="position: absolute;left: 678px;top: 22px;"
              @click="updateBasicInfo()"
            >保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
  data() {
    return {
      form: {
        UserId: "",
        Name: "",
        CoverUrl: "",
        Gender: "",
        IDNumber: "",
        Desc: "",
        School:"",
        Number:"",
        mobile:""
      },
      schoolList:[],
      count: 60,
      show1: true,
      show2: false,
      show3: false,
      isLoginTab: "account",
      PhoneCode:"",
      verifyCode:"",
      urlAliyunOSS: "/api/design/osssign/getsign"
    };
  },
  props: {
    wsxx:{
      type:Boolean,
      default:false
    }
  },
  components: {
    imageUpload
  },
  created() {
    this.getBasicInfo();
    this.getSchoolList();
  },
  methods: {
    getBasicInfo() {
      let self = this;
      this.$http.get("/api/XOrg/StudentManager/getUserInfo").then(function(res) {
        if (res.code == 1) {
          self.form.UserId = res.userInfo.id;
          self.form.Name = res.userInfo.name;
          self.form.CoverUrl = res.userInfo.cover;
          self.form.Gender = res.userInfo.gender;
          self.form.IDNumber = res.userInfo.iDNumber;
          self.form.Desc = res.userInfo.description;
          self.form.Number = res.userInfo.Number;
          self.form.School = res.userInfo.School;
          self.form.mobile = res.userInfo.mobile;
        }
      });
    },
    getSchoolList() {
      let self = this;
      this.$http.get("/api/XOrg/StudentManager/getSchoolList").then(function(res) {
        if (res.code == 1) {
          self.schoolList = res.schoolList;
        }
      });
    },
    testid(card) {
      var str, result = 0;
        card = card.toUpperCase();
        if (card.length === 18) {
            var map1 = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
                map2 = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];

            str = new String(card);
            for (var i = 0, len = str.length; i < (len - 1); i++) {
                result += str[i] * map1[i];
            }
            if (map2[(result % 11)] != str[len - 1]) {
                return "请填写正确的身份证号码！"
            }else{
                return "1"
            }
        }else{
          return "请填写正确的身份证号码！";
        }
    },
    updateBasicInfo() {
      let self = this;
      var code= self.testid(this.form.IDNumber);
      if(code!=1){
        this.$message({
          showClose: true,
          message: code,
          type: 'warning'
        });
        return false;
      }
      this.$http.post("/api/XOrg/StudentManager/updateBasicInfo", {
          userId: this.form.UserId,
          name: this.form.Name,
          coverUrl: this.form.CoverUrl,
          gender: this.form.Gender,
          iDNumber: this.form.IDNumber,
          desc: this.form.Desc,
          Number:this.form.Number,
          School:this.form.School,
        }).then(function(res) {
          if (res.code == 1) {
            self.$message.success(res.msg);
            self.getBasicInfo();
 			self.$emit('closeDilog');
            self.$emit("update:state",true);
          }
        });
    }
  }
};
</script>

<style lang="scss">
.wlx-stu-self-info-wrapper{
  .stu-self-form{
    width: 50%;
  }
}
</style>
